/**
 * @generated SignedSource<<3575eb49cb8cf55ac89a1b018b256144>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AutoShareToChannelsRemoveChannelMutation$variables = {
  channelId: string;
  streamId: string;
};
export type AutoShareToChannelsRemoveChannelMutation$data = {
  readonly streamAutoShareSettingsRemoveChannel: {
    readonly streamAutoShareSettings: {
      readonly channels: ReadonlyArray<{
        readonly id: string;
        readonly isPrivate: boolean;
        readonly name: string;
      }>;
    };
  } | null;
};
export type AutoShareToChannelsRemoveChannelMutation = {
  response: AutoShareToChannelsRemoveChannelMutation$data;
  variables: AutoShareToChannelsRemoveChannelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "channelId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "channelId",
    "variableName": "channelId"
  },
  {
    "kind": "Variable",
    "name": "streamId",
    "variableName": "streamId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AutoShareToChannelsRemoveChannelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StreamAutoShareSettingsRemoveChannel",
        "kind": "LinkedField",
        "name": "streamAutoShareSettingsRemoveChannel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StreamAutoShareSettings",
            "kind": "LinkedField",
            "name": "streamAutoShareSettings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "channels",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AutoShareToChannelsRemoveChannelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StreamAutoShareSettingsRemoveChannel",
        "kind": "LinkedField",
        "name": "streamAutoShareSettingsRemoveChannel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StreamAutoShareSettings",
            "kind": "LinkedField",
            "name": "streamAutoShareSettings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "channels",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "56a5837a7f876c8a679e1515e789ed7f",
    "id": null,
    "metadata": {},
    "name": "AutoShareToChannelsRemoveChannelMutation",
    "operationKind": "mutation",
    "text": "mutation AutoShareToChannelsRemoveChannelMutation(\n  $streamId: ID!\n  $channelId: ID!\n) {\n  streamAutoShareSettingsRemoveChannel(streamId: $streamId, channelId: $channelId) {\n    streamAutoShareSettings {\n      channels {\n        __typename\n        id\n        name\n        isPrivate\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "834c7efd6c525968c96c205ea9a30682";

export default node;
